import { render, staticRenderFns } from "./SubjectAdd.vue?vue&type=template&id=47735206&"
import script from "./SubjectAdd.vue?vue&type=script&lang=js&"
export * from "./SubjectAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports